/** Match gateway list / SensorCard thresholds (minutes since last data). */
export const getGatewayStatusFromMinutesAgo = (minutesAgo) => {
  if (minutesAgo === null || minutesAgo === undefined) return 'offline';
  if (minutesAgo < 0) return 'online';
  if (minutesAgo <= 15) return 'online';
  if (minutesAgo <= 60) return 'warning';
  return 'offline';
};

export const normalizeGatewayStatus = (status) => {
  if (status === 'online' || status === 'warning' || status === 'offline') return status;
  return 'offline';
};

export const cleanGatewayMac = (mac) => (mac ? String(mac).replace(/[^0-9A-Fa-f]/g, '').toUpperCase() : '');

export const gatewayMessageMatches = (msg, mac, topic) => {
  if (!msg?.topic) return false;
  const t = String(msg.topic);
  const cleanMac = cleanGatewayMac(mac);
  if (cleanMac && t.includes(cleanMac)) return true;
  return !!(topic && t === topic);
};

export const getLastGatewayMessage = (messages = [], mac, topic) => {
  for (const msg of messages) {
    if (gatewayMessageMatches(msg, mac, topic)) return msg;
  }
  return null;
};

export const getGatewayStatusFromLiveMessages = (messages = [], mac, topic) => {
  const lastMsg = getLastGatewayMessage(messages, mac, topic);
  const ts = lastMsg?.timestamp || lastMsg?.received_at;
  if (!ts) return null;

  const minutesAgo = Math.floor((Date.now() - new Date(ts).getTime()) / 60000);
  return getGatewayStatusFromMinutesAgo(minutesAgo);
};

export const formatMacFromClean = (clean) => {
  if (!clean || clean.length !== 12) return clean || '';
  return clean.match(/.{2}/g).join(':').toUpperCase();
};

export const findAccountGateway = (gateways = [], { gatewayId, macAddress } = {}) => {
  if (gatewayId) {
    const byId = gateways.find((g) => String(g.id) === String(gatewayId));
    if (byId) return byId;
  }
  const cleanMac = cleanGatewayMac(macAddress);
  if (!cleanMac) return null;
  return gateways.find((g) => {
    const gwMac = cleanGatewayMac(g.mac_address) || cleanGatewayMac(g.gateway_mac_hex);
    return gwMac && gwMac === cleanMac;
  }) || null;
};

/** Resolve hardware status for a canvas gateway node. */
export const resolveGatewayNodeStatus = ({
  accountGateway,
  liveMessages = [],
  macAddress,
  mqttTopic,
  fallbackStatus,
}) => {
  const liveStatus = getGatewayStatusFromLiveMessages(liveMessages, macAddress, mqttTopic);
  if (liveStatus) return liveStatus;

  if (accountGateway?.status) {
    return normalizeGatewayStatus(accountGateway.status);
  }

  return normalizeGatewayStatus(fallbackStatus);
};

export const gatewayStatusLabel = (status) => {
  switch (normalizeGatewayStatus(status)) {
    case 'online':
      return 'Online';
    case 'warning':
      return 'Stale';
    default:
      return 'Offline';
  }
};
